require("./wdh-legacy/form/js/corporate-template/component-form.js");